import React from 'react';
import { Glyphicon, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap'
import * as Formatting from 'fw/misc/Formatting'
import { TextBox, MaskedBox } from 'fw/forms'
import CountryDialCodes from 'fw/forms/helpers/CountryDialCodes.json'

class PhoneBox extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			types: props.types || [],
			selectedType: (props.value && Formatting.capitalize(props.value.phoneTypeCode)) || (props.types && props.types[0]),
			extension: props.value && (props.value.extension || ""),
			countryCode: (props.value && props.value.countryCode) || "+1",
			showExtension: props.showExtension,
			countryFlag: null
		};
	}

	// Public
	setValue = (value) => { this._input.setValue(value); }
	getValue = () => { return this.inputBoxValueBuilder(this._input.getValue()) }
	focus = () => { this._input.focus(); }
	select = () => { this._input.select(); }
	flag = (status) => { this._input.flag(status); }
	completed = () => { return this._input.completed(); }
	validate = () => { return this._input.validate(); }

	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt(this);
	}

	handleSelectType(item) {
		this.setState({ selectedType: item },
			function () {
				const me = this;
				var value = this.inputBoxValueBuilder(this._input.getValue());

				// If managed by forms, trigger field change, then change
				if (this.props.managed)
					this.props.onFieldChange(value, this.props.name, function () { me.onChange(value); });
				else
					this.onChange(value);

				this.onDirt();
			}
		);
	}

	handleSelectCountryCode(item) {
		this.setState({ countryCode: item.phone[0], countryFlag: item.image },
			function () {
				const me = this;
				var value = this.inputBoxValueBuilder(this._input.getValue());

				// If managed by forms, trigger field change, then change
				if (this.props.managed)
					this.props.onFieldChange(value, this.props.name, function () { me.onChange(value); });
				else
					this.onChange(value);

				this.onDirt();
			}
		);
	}

	listMenuItem = () => {
		return (
			this.state.types.map((item) => {
				return <MenuItem key={item} onClick={() => this.handleSelectType(item)} >{item}</MenuItem>
			})
		);
	}

	listCountryDialCodeMenuItem = () => {
		return (
			Object.values(CountryDialCodes).map((item) => {
				return (
					<MenuItem key={item.name} onClick={() => this.handleSelectCountryCode(item)}>
						<img src={item.image} alt={`${item.name} flag`} style={{ width: "30px", height: "30px" }} />{`  ${item.name} (${item.phone[0]})`}
					</MenuItem>
				);
			})
		);
	}

	// Events
	onChange = (value) => {
		this.props.onChange && this.props.onChange(value);
	}

	handleExtensionChange = (v) => {
		this.setState({ extension: v },
			function () {
				const me = this;
				var value = this.inputBoxValueBuilder(this._input.getValue());

				// If managed by forms, trigger field change, then change
				if (this.props.managed)
					this.props.onFieldChange(value, this.props.name, function () { me.onChange(value); });
				else
					this.onChange(value);

				this.onDirt();
			}
		);
	}

	inputBoxValueBuilder = (value) => {
		if (this.props.types) {
			return {
				phoneId: (this.props.value && this.props.value.phoneId) || null,
				phoneTypeCode: this.state.selectedType,
				number: value || "",
				extension: this.state.extension,
				countryCode: this.state.countryCode || "+1",
			}
		}
		else {
			return value;
		}
	}

	// React
	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.value !== this.props.value
			|| nextProps.placeholder !== this.props.placeholder
			|| nextProps.disabled !== this.props.disabled
			|| nextState.selectedType !== this.state.selectedType
			|| nextState.extension !== this.state.extension
			|| nextState.countryCode !== this.state.countryCode);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.value !== this.props.value) {
			if (this.props.value) {
				this.setState({
					selectedType: (this.props.value.phoneTypeCode && Formatting.capitalize(this.props.value.phoneTypeCode)) || (this.props.types && this.props.types[0]),
					countryCode: this.props.value && this.props.value.countryCode,
					extension: this.props.value && this.props.value.extension,
				});
			} else {
				this.setState({
					selectedType: this.props.types && this.props.types[0],
					countryCode: "+1",
					extension: null,
				});
			}
		}
	}

	renderCountryCodeDropdown = () => {
		return (
			<Dropdown id="countryCode" disabled={this.props.disabled}>
				<Dropdown.Toggle noCaret>
					{this.state.countryCode}
				</Dropdown.Toggle>
				<Dropdown.Menu style={{ maxHeight: "300px", overflowY: "scroll" }}>
					{this.listCountryDialCodeMenuItem()}
				</Dropdown.Menu>
			</Dropdown>
		);
	}

	render() {
		let props = {
			...this.props,
			valueBuilder: this.inputBoxValueBuilder
		}

		// If using types, take the value for the input, from the { value, type } object
		if (this.props.types && this.props.value)
			props = { ...props, value: this.props.value.number };

		const mask = this.state.countryCode === "+1" || !this.state.countryCode ? "(999) 999-9999" : "9999999999999";

		return (
			<div className="input-group">
				<div className="input-group-addon">
					{this.state.countryFlag ?
						<img src={this.state.countryFlag} alt='Country flag' style={{ width: "20px", height: "20px" }} />
						:
						<Glyphicon glyph="earphone" />
					}
				</div>
				{this.state.types.length > 0 ?
					<React.Fragment>
						<DropdownButton id="ddlType" title={this.state.selectedType} disabled={this.props.disabled} style={{ width: "70px" }} >
							{this.listMenuItem()}
						</DropdownButton>
						{props.showCountryCode && this.renderCountryCodeDropdown()}
						<div className="input-group-btn">
							<MaskedBox mask={mask} maskChar={null} placeholder="Phone Number" {...props} ref={(input) => this._input = input} />
							{this.state.showExtension && this.state.selectedType === "Office" &&
								<TextBox placeholder="Ext." value={this.state.extension} disabled={this.props.disabled} onChange={this.handleExtensionChange} maxLength={10} style={{ width: "53px" }} />
							}
						</div>
					</React.Fragment>
				:
					<React.Fragment>
						{props.showCountryCode && this.renderCountryCodeDropdown()}
						<div className="input-group-btn">
							<MaskedBox mask={mask} maskChar={null} placeholder="Phone Number" {...props} ref={(input) => this._input = input} />
							{this.state.showExtension && this.state.selectedType === "Office" &&
								<TextBox placeholder="Ext." value={this.state.extension} disabled={this.props.disabled} onChange={this.handleExtensionChange} maxLength={10} style={{ width: "53px" }} />
							}
						</div>
					</React.Fragment>
				}
			</div>)
	}
}

export default PhoneBox;

// Mark this as a form component
PhoneBox.defaultProps = {
	formControl: true,
	managed: false,
	showExtension: false,
	showCountryCode: false
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/phoneBox/PhoneBox.js